/*eslint no-self-assign: 0*/
export function enrichAccount(account) {
  // OBSOLETE: Use the new report endpoint where this is accounted for.
  switch (account.typeOfAuditorAssistance) {
    case 'Andre erklæringer uden sikkerhed':
    case "Andre erklæringer med sikkerhed":
      account.typeOfAuditorAssistance = 'Andre erklæringer'
      break


    case "Auditor's report on audited financial statements":
    case "Revisionspåtegning":
    case "Auditor's reports (Other non-assurance reports)":
      account.typeOfAuditorAssistance = 'Revision'
      break


    case "Auditor's report on extended review":
    case "Erklæring om udvidet gennemgang":
      account.typeOfAuditorAssistance = 'Udvidet gennemgang'
      break

    case "Ingen bistand":
    case "No audit assistance":
      account.typeOfAuditorAssistance = 'Ingen erklæring'
      break


    case "The independent auditor's reports (Review)":
    case "Den uafhængige revisors erklæringer (review)":
      account.typeOfAuditorAssistance = 'Review'
      break


    default:
      account.typeOfAuditorAssistance = account.typeOfAuditorAssistance
      break
  }
}
export const keyfigures = [
  {
    title: 'Omsætning',
    name: 'revenue',
    tooltip: 'Omsætningen består af alle virksomhedens samlede indtægter',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Bruttofortjeneste',
    name: 'grossResult',
    tooltip: 'En virksomheds omsætning minus dens vareforbrug',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Afskrivninger',
    name: 'depreciations',
    tooltip: 'Den værdi et anlægsaktiv skal nedreguleres med i løbet af det pågældende anlægsgodes resterende brugstid',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Driftsresultat',
    name: 'profitFromOrdinaryOperatingActivities',
    tooltip: 'Et selskabs primære driftsresultat (EBIT)',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Finansielle omkostninger',
    name: 'otherFinanceExpenses',
    tooltip: 'Andre finansielle omkostninger',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Resultat før skat',
    name: 'resultBeforeTax',
    tooltip: 'Årets resultat før skattepligtlige indkomst (EBT)',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Årets resultat',
    name: 'result',
    tooltip: 'Omsætning fratrukket alle udgifter',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Udbytte',
    name: 'dividend',
    tooltip: 'Valgfri årlig udbetaling af virksomhedens overskud',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Personaleomkostninger',
    name: 'employeeExpenses',
    tooltip: 'Omkostninger til personaleydelser',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Selskabskapital',
    name: 'capital',
    tooltip: 'Indskudt kapital i selskabet',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Balance',
    name: 'liabilitiesAndEquity',
    tooltip: 'Overblik over værdien af aktiver og passiver',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Antal ansatte',
    name: 'employees',
    tooltip: 'Gennemsnitlig antal ansatte for perioden',
    type: 'employees',
    filter: [ 'all', 'lassodk-all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Erklæring',
    name: 'typeOfAuditorAssistance',
    tooltip: 'Revisor kan give forskellige erklæringer med sikkerhed på et årsregnskab, der angiver forskellige grader af sikkerhed for oplysningerne.',
    type: 'text',
    filter: [ 'all' ],
    group: 1,
    isPremium: true
  },
  {
    title: 'Regnskabsperiode',
    name: 'period',
    value: '',
    tooltip: 'Perioden som regnskabet dækker over',
    type: 'date',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Regnskab udgivet',
    name: 'publicationTime',
    value: '',
    tooltip: 'Datoen som regnskabet blev udgivet',
    type: 'publicationTime',
    filter: [ 'all' ],
    group: 1,
    isPremium: false
  },
  {
    title: 'Samlede aktiver',
    name: 'assets',
    tooltip: 'Aktiver er ting, der typisk har en levetid på over et år. Det kan eksempelvis være en bil, inventar, goodwill, patenter og lignende',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Anlægsaktiver',
    name: 'nonCurrentAssets',
    tooltip: 'Materielle, immaterielle eller finansielle aktiver som har en langsigtet værdi',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Grunde og bygninger',
    name: 'landAndBuildings',
    tooltip: 'Investeringer i fast ejendom',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Omsætningsaktiver',
    name: 'currentAssets',
    tooltip: 'Værdien af virksomhedens beholdninger, som ikke er anskaffet med henblik på vedvarende eje eller brug, samt værdien af kortfristede tilgodehavender',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Varebeholdning',
    name: 'inventories',
    tooltip: 'Virksomhedens samlede varer',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Varedebitor',
    name: 'shorttermTradeReceivables',
    tooltip: 'Kunder, som skylder virksomheden penge for modtagne varer',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Likvider',
    name: 'cashHoldings',
    tooltip: 'Virksomhedens beholdning af kontante midler samt dens bank- og giroindeståender',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 2,
    isPremium: false
  },
  {
    title: 'Egenkapital',
    name: 'equity',
    tooltip: 'Udtryk for selskabets værdi og groft sagt summen af ejendele minus summen af gæld',
    type: 'object',
    filter: [ 'all', 'lassodk-all', 'summary', 'medium' ],
    group: 3,
    isPremium: false,
  },
  {
    title: 'Ansvarlig lånekapital',
    name: 'equityLoan',
    tooltip: 'Lånekapital, som långiver selv har taget ansvaret for',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 3,
    isPremium: false
  },
  {
    title: 'Hensættelser',
    name: 'provisions',
    tooltip: 'Økonomiske forpligtelser, hvis endelige værdi eller forfaldstidspunkt ikke er fastlagt på balancetidspunktet',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 3,
    isPremium: false
  },
  {
    title: 'Langfristet gæld',
    name: 'longtermLiabilities',
    tooltip: 'Gæld, der forfalder senere end om et år',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 3,
    isPremium: false
  },
  {
    title: 'Kortfristet gæld',
    name: 'shorttermLiabilities',
    tooltip: 'Gæld, der forfalder inden for et år',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 3,
    isPremium: false
  },
  {
    title: 'Dækningsgrad',
    name: 'coverage',
    tooltip: 'Udtryk for hvor stort et beløb en virksomhed har tilbage efter de direkte salgsomkostninger, til at betale faste omkostninger i virksomheden',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'Overskudsgrad',
    name: 'operatingMargin',
    tooltip: 'Udtryk for hvor stor en del af virksomhedens omsætning, overskuddet udgøres af',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'Afkastningsgrad',
    name: 'roi',
    tooltip: 'Måler hvorvidt virksomheden er i stand til at genere overskud ud fra den indskudte kapital',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'Likviditetsgrad',
    name: 'liquidityRatio',
    tooltip: 'Forholdet mellem omsætningsaktiver og kortfristet gæld',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'Soliditetsgrad',
    name: 'solvencyRatio',
    tooltip: 'Udtryk for virksomhedens modstandsdygtighed over for eventuelle tab',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'Egenkapitalforrentning',
    name: 'equityReturn',
    tooltip: 'Udtryk for hvordan den indskudte kapital forrentes',
    type: 'percentage',
    filter: [ 'all', 'lassodk-all' ],
    group: 4,
    isPremium: true
  },
  {
    title: 'EBITDA',
    name: 'ebitda',
    tooltip: 'Driftsresultat før goodwill og afskrivninger på driftsaktiviteter',
    type: 'object',
    filter: [ 'all', 'lassodk-all' ],
    group: 4,
    isPremium: false
  },
  {
    title: 'Bankforbindelse',
    // name: ['identificationNumberCvrOfFinancialInstitution', 'nameOfFinancialInstitution'],
    name: 'bankName',
    tooltip: 'Virksomhedens bankforbindelse indberettet i pågældende XBRL-regnskab',
    type: 'text',
    filter: [ 'all' ],
    group: 2,
    isPremium: true
  },
  {
    title: 'Regnskabsklasse',
    name: 'classOfReportingEntity',
    value: '',
    tooltip: 'Klassen som regnskabet er blevet tildelt',
    type: 'text',
    filter: [ 'all', 'lassodk-all', 'medium' ],
    group: 1,
    isPremium: true
  },
]
